var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"primary","disabled":_vm.processando || !_vm.habilitado}},[(!_vm.processando)?_vm._t("default"):_vm._e(),(_vm.processando)?_c('span',[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}),_vm._v("  PROCESSANDO")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }